// export const GET_PATIENT_PERSONAL_PROFILE = POLARIS_API_PREFIX + "/v2/users/user/userId/profile";
// export const GET_PATIENT_PERSONAL_PROFILE_OTHER = POLARIS_API_PREFIX + "/v2/users/user/userId-patientId/profile";
// export const SAVE_ALL_PROFILES_FOR_PATIENT = POLARIS_API_PREFIX + "/v2/users/userId/profiles";
// export const SAVE_ALL_PROFILES_FOR_PATIENT_OTHER = POLARIS_API_PREFIX + "/v2/users/userId-patientId/profiles";

import {IPolarisApis} from "./IPolarisApis";

export default class PolarisApis implements IPolarisApis {
	// saveAllProfilesForPatient(curefitId: number, patientId: number, isSelf: boolean, allProfiles: PatientPersonalProfile): Promise<any> {
	// 	let urlString: string = isSelf
	// 		? SAVE_ALL_PROFILES_FOR_PATIENT.replace(USER_ID_PARAM, curefitId.toString())
	// 		: SAVE_ALL_PROFILES_FOR_PATIENT_OTHER.replace(USER_ID_PARAM, curefitId.toString()).replace(PATIENT_ID_PARAM, patientId.toString());
	// 	let currUrl: string = ApiUtils.createApiUrl(urlString);
	// 	var profiles = AppUtils.getDeepCopiedObject(allProfiles);
	// 	profiles.personalInformation && profiles.personalInformation.commute
	// 		? (profiles.personalInformation.commute.value = AppUtils.getTimeInSecondsFromMinutes(profiles.personalInformation.commute.value))
	// 		: undefined;
	// 	profiles.personalInformation && profiles.personalInformation.sittingTime
	// 		? (profiles.personalInformation.sittingTime.value = AppUtils.getTimeInSecondsFromHours(profiles.personalInformation.sittingTime.value))
	// 		: undefined;
	// 	return ApiUtils.apiPostRequest(currUrl, JSON.stringify(profiles));
	// }
	//
	// getPatientPersonalProfile(curefitId: number, patientId: number, isSelf: boolean): Promise<PatientPersonalProfile> {
	// 	let urlString: string = isSelf
	// 		? GET_PATIENT_PERSONAL_PROFILE.replace(USER_ID_PARAM, curefitId.toString())
	// 		: GET_PATIENT_PERSONAL_PROFILE_OTHER.replace(USER_ID_PARAM, curefitId.toString()).replace(PATIENT_ID_PARAM, patientId.toString());
	// 	let currUrl: string = ApiUtils.createApiUrl(urlString);
	// 	return ApiUtils.apiGetRequest(currUrl, true);
	// }
}
